/**
 * Environment configuration for the frontend application
 */
export const env = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:4000',
  nodeEnv: import.meta.env.VITE_NODE_ENV || 'development',
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
  isMaintenance: import.meta.env.VITE_MAINTENANCE === 'true',
  analytics: {
    posthogApiKey: import.meta.env.VITE_PUBLIC_POSTHOG_KEY || '',
    posthogHost:
      import.meta.env.VITE_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com',
    enabled: import.meta.env.VITE_ENABLE_ANALYTICS === 'true',
    sessionRecordingEnabled: import.meta.env.VITE_ENABLE_SESSION_RECORDING === 'true',
  },
} as const

export type Env = typeof env
